<template>
  <div>

    <div class="element-item-list">
      <div class="element-item">
        <div class="element-group mb-4">
          <div class="text-lg font-bold">{{$t('client.complectation.engraving')}}</div>
        </div>

        <div
          class="element-detail mb-4"
          v-for="face in faces"
          :key="`face-compectation-${face.face_id||face.order_face_id}`"
        >
          <div
            class="detail"
            v-if="face.elements.length||face.texts.length"
          >
            <div class="mb-2 flex justify-between">
              <div
                class="complectation-face-name"
                v-html="face.faceName||face.name"
              ></div>
              <button
                v-if="isComplectation"
                class="font-thin"
                @click="removeFace(face.face_id)"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div v-if="face.texts.length">
              <div
                class="flex w-full mb-1 justify-between gap-2 items-start text-xs"
                v-for="txt in face.texts"
                :key="`face-txt-compectation-${txt.text_id}`"
              >
                <div>
                  {{ txt.text }} ({{$t('main.symbols')}}: {{ txt.text.length }}; шрифт: {{ txt.font&&txt.font.name||txt.font_family }}; размер, см: {{ txt.size&&txt.size.height||txt.font_size }}; коэф.: {{ txt.size&&txt.size.cost_coefficient||txt.cost_coefficient }};сверху, см: {{ txt.offsetTop }} слева, см: {{ txt.offsetLeft }})
                </div>

                <div class="flex align-center gap-1">
                  <div v-if="txt.total && settings.with_calc_price == 1">
                    {{ $toCurrency(txt.total) }}
                  </div>
                  <button
                    v-if="isComplectation"
                    class="font-thin"
                    @click="removeText(face, txt)"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <div
              v-if="face.elements.length"
              class="text-xs"
            >
              <div
                class="flex w-full mb-1 gap-1 justify-between items-center"
                v-for="el in face.elements"
                :key="`face-element-compectation-`+Math.random()"
              >
                <div>
                  {{ el.name }}
                  (<span>арт.: {{ el.article }}</span><span v-if="el.width||el.height">; размер: {{ el.width }}x{{ el.height }} см</span><span>; сверху, см: {{ el.offsetTop }}</span><span>; слева, см: {{ el.offsetLeft }}</span><span v-if="el.angle">; угол, &deg;: {{ el.angle }}
                  </span><span v-if="el.mirrored">; отражён</span>)
                </div>

                <div class="flex align-center gap-1">
                  <div v-if="(el.size) && settings.with_calc_price == 1">
                    {{ $toCurrency(el.size.price) }}
                  </div>
                  <div v-else-if="(el.price) && settings.with_calc_price == 1">
                    {{ $toCurrency(el.price) }}
                  </div>
                  <button
                    v-if="isComplectation"
                    class="font-thin"
                    @click="removeEngraving(face, el)"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex justify-between"
      v-if="settings.with_calc_price == 1"
    >
      <div class="font-bold">{{$t('client.complectation.cost_engraving')}}</div>
    <div class="font-bold text-xl">{{ $toCurrency(engravingTotal) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    faces: {
      type: Array,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    isComplectation: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    removeFace(face_id) {
      this.$store.dispatch("clientOrder/removeEngravingFaceElements", face_id);
      this.$store.dispatch("ClientEngravingSettings/clear");
    },
    removeEngraving(face, el) {
      this.$store.dispatch("clientOrder/removeEngraving", {
        face_id: face.face_id,
        element_id: el.element_id,
        uuid: el.uuid,
      });
      this.$store.dispatch("ClientEngravingSettings/clear");
    },
    removeText(face, txt) {
      this.$store.dispatch("clientOrder/removeText", {
        face_id: face.face_id,
        text_id: txt.text_id,
      });
      this.$store.dispatch("ClientEngravingSettings/clear");
    },
  },
  computed: {
    engravingTotal() {
      let total = 0;
      for (const i in this.faces) {
        let faceTotal = 0;
        if (this.faces[i].elements.length > 0) {
          for (const element of this.faces[i].elements) {
            if (
              element.size &&
              element.size.price &&
              parseFloat(element.size.price)
            ) {
              faceTotal += parseFloat(element.size.price);
            } else if (element.price && parseFloat(element.price)) {
              faceTotal += parseFloat(element.price);
            }
          }
        }
        if (this.faces[i].texts.length > 0) {
          for (const txt of this.faces[i].texts) {
            if (txt.total) {
              faceTotal += parseFloat(txt.total);
            }
          }
        }
        total += faceTotal;
      }
      return total;
    },
  },
};
</script>
